import { useEnPantalla } from '@/shared/hooks/useEnPantalla'

/**
 * A-06 · Revelado al hacer scroll.
 *
 * Devuelve la ref del elemento y las clases que le tocan. Aparece cuando va al
 * 15% visible y no se repite al volver a subir; el observador vive en
 * useEnPantalla.
 *
 * `retraso` escalona una fila de tarjetas; va en milisegundos y solo aplica a
 * la primera aparición.
 */
export function useRevelado<T extends HTMLElement = HTMLDivElement>(retraso = 0) {
  const { ref, visible } = useEnPantalla<T>()

  return {
    ref,
    className: visible ? 'revelar revelar-visible' : 'revelar',
    style: retraso ? { transitionDelay: `${retraso}ms` } : undefined,
  }
}
